import React, {useEffect, useState} from 'react'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import SendIcon from '@mui/icons-material/Send'
import {Box} from '@mui/material'

export default function DialogFormActions({dialogRef, onClose }) {
  const [buttonPosition, setButtonPosition] = useState({ top: 0, right: 0 });

  useEffect(() => {
    const updateButtonPosition = () => {
      if (dialogRef.current) {
        const rect = dialogRef.current.getBoundingClientRect();
        setButtonPosition({
          top: rect.top + 10, // 10px from the top of the Dialog
          right: window.innerWidth - rect.right + 10, // 10px from the right of the Dialog
        });
      }
    };

    setTimeout(() => {
      updateButtonPosition();
    }, 100)

    // Listen for window resize to adjust button position
    window.addEventListener("resize", updateButtonPosition);
    return () => window.removeEventListener("resize", updateButtonPosition);
  }, []);

  return (
    <Box className="core-dialog-actions"
                   sx={{
                     position: "fixed",
                     top: buttonPosition.top - 30,
                     right: buttonPosition.right - 100,
                   }}
    >
      <Button
        onClick={onClose}
        variant="contained"
        color="error"
        className="btn-cancel animate__animated animate__fadeInUp"
      >
        <CloseIcon sx={{color: '#ffffff'}}></CloseIcon>
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="success"
        className="btn-submit animate__animated animate__fadeInUp"
      >
        <SendIcon sx={{color: '#ffffff'}}></SendIcon>
      </Button>
    </Box>
  )
};
